import { DEFAULT_LOCALE, LOCALES } from '../domain/enums';
import { isLocale } from './translator';
/**
 * Dil seçiminin KALICILIĞI için ortak sözleşme (Story 0.3:
 * "kullanıcı dilini değiştirdi → uygulama yeniden başlatılır → seçim kalıcıdır").
 *
 * Web çerez, mobil cihaz deposu kullanır; kural ve anahtar adı burada TEK yerde durur
 * ki iki uygulama aynı problemi iki farklı desenle çözmesin.
 */
export const LOCALE_STORAGE_KEY = 'wb_locale';
/** Seçimin kalıcılık süresi (gün) — çerez ömrü. */
export const LOCALE_COOKIE_MAX_AGE_DAYS = 365;
/** `wb_locale=en; Path=/; Max-Age=…` biçiminde çerez değeri üretir. */
export function buildLocaleCookie(locale) {
    const maxAge = LOCALE_COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
    return `${LOCALE_STORAGE_KEY}=${locale}; Path=/; Max-Age=${maxAge}; SameSite=Lax`;
}
export function parseLocaleCookie(cookieHeader) {
    if (!cookieHeader)
        return null;
    for (const part of cookieHeader.split(';')) {
        const [name, value] = part.trim().split('=');
        if (name === LOCALE_STORAGE_KEY && isLocale(value))
            return value;
    }
    return null;
}
/** `/tr/etkinlikler` → `/en/etkinlikler` (yol önekini değiştirir). */
export function replaceLocaleInPath(pathname, locale) {
    const segments = pathname.split('/');
    if (segments.length > 1 && isLocale(segments[1])) {
        segments[1] = locale;
        return segments.join('/');
    }
    return `/${locale}${pathname === '/' ? '' : pathname}`;
}
export function nextLocale(current) {
    const index = LOCALES.indexOf(current);
    return LOCALES[(index + 1) % LOCALES.length] ?? DEFAULT_LOCALE;
}
//# sourceMappingURL=locale-storage.js.map